import yup from 'core/utils/validators';
import { EmploymentTypes, MainSourceOfIncomeTypes } from 'types';
import {
  FIELD_REQUIRED,
  MESSAGE_FIRST_NUMBER_NO_VALID,
  getMaxLength,
  phoneRegExp,
  validPhoneCodes,
  MIN_LENGTH_12,
  FIELD_MIN_TWO_LENGTH,
} from 'const';

const { object, string } = yup;

export const EmploymentDetailsFormSchema =
  (employmentType: EmploymentTypes | null, sourceOfIncomeTypes: MainSourceOfIncomeTypes | null) =>
  () => {
    const base = {
      employment_type: string().nullable().required(FIELD_REQUIRED),
    };

    const monthlyIncome = {
      monthly_income: string().max(6, getMaxLength(6)).required(FIELD_REQUIRED),
      employment_salary_day_in_month: string().nullable().required(FIELD_REQUIRED),
    };

    const sourceOfIncome = {
      main_source_of_income: string().nullable().required(FIELD_REQUIRED),
    };

    switch (employmentType) {
      case EmploymentTypes.SALARIED:
      case EmploymentTypes.GOVERNMENT_EMPLOYEE:
      case EmploymentTypes.POLICE_MILITARY:
      case EmploymentTypes.LEGAL_SERVICES:
        return object().shape({
          ...base,
          ...monthlyIncome,
          employment_duration_in_last_place: string().nullable().required(FIELD_REQUIRED),
          employment_company_name: string()
            .min(2, FIELD_MIN_TWO_LENGTH)
            .max(50, FIELD_MIN_TWO_LENGTH)
            .required(FIELD_REQUIRED),
          employment_company_phone_number: string()
            .validateCodePhone(validPhoneCodes, MESSAGE_FIRST_NUMBER_NO_VALID)
            .matches(phoneRegExp, MIN_LENGTH_12)
            .required(FIELD_REQUIRED),
        });

      case EmploymentTypes.SELF_EMPLOYED:
        return object().shape({
          ...base,
          ...monthlyIncome,
          employment_duration_in_last_place: string().nullable().required(FIELD_REQUIRED),
        });

      case EmploymentTypes.UNEMPLOYED:
        switch (sourceOfIncomeTypes) {
          case MainSourceOfIncomeTypes.PART_TIME_JOB:
          case MainSourceOfIncomeTypes.SOCIAL_PAYMENTS:
            return object().shape({
              ...base,
              ...monthlyIncome,
            });
          case MainSourceOfIncomeTypes.HELP_OF_RELATIVES:
          case MainSourceOfIncomeTypes.NO_INCOME:
            return object().shape({
              ...base,
              ...sourceOfIncome,
            });
        }

        return object().shape({
          ...base,
          ...sourceOfIncome,
        });

      default:
        return object().shape(base);
    }
  };
